export default class AccessHandler {
    constructor($window, $rootScope, CurrentAccount) {
        this._window = $window;
        this._rootScope = $rootScope;
        this.currentAccount = CurrentAccount;
    }

    setRoles(roles) {
        this._window.localStorage.setItem('roles', JSON.stringify(roles));
        this._rootScope.$emit('user:roles:set');
    };

    hasRole(requestedRoles) {
        var roles = this.getRoles(), hasRole = false;

        _.map(roles, (role) => {
            if (requestedRoles.indexOf(role.name) > -1) {
                hasRole = true;
            }
        });

        return hasRole;
    };

    isRuler() {
        return this.hasRole('Ruler');
    };

    hasPermission(requestedPermission) {
        var roles = this.getRoles(), hasPermission = false;

        _.map(roles, (role) => {
            _.map(role.permissions, (permission) => {
                if (requestedPermission == permission.name) {
                    hasPermission = true;
                }
            });
        });

        return hasPermission;
    };

    getRoles() {
        var rolesString = this._window.localStorage.getItem('roles');
        return JSON.parse(rolesString);
    };

    remove() {
        localStorage.removeItem('roles');
    };

    isAccount(accountIds) {
        return accountIds.indexOf("" + this.currentAccount.data.account.id) !== -1;
    }
}

AccessHandler.$inject = ['$window', '$rootScope', 'CurrentAccount'];
